import { create } from 'zustand';
import { en } from './en';
import { zh } from './zh';
import { Language, TranslationKey, TranslationKeys } from './types';

export type { Language, TranslationKey };

const translations: Record<Language, TranslationKeys> = { en, zh };

interface LanguageState {
  language: Language;
  setLanguage: (language: Language) => void;
}

const getInitialLanguage = (): Language => {
  try {
    const stored = localStorage.getItem('clb-language');
    if (stored === 'en' || stored === 'zh') return stored;
  } catch {}
  return 'en';
};

export const useLanguageStore = create<LanguageState>((set) => ({
  language: getInitialLanguage(),
  setLanguage: (language) => {
    try {
      localStorage.setItem('clb-language', language);
    } catch {}
    set({ language });
  },
}));

export function useTranslation() {
  const { language, setLanguage } = useLanguageStore();

  const t = (key: TranslationKey): string => {
    return translations[language][key];
  };

  return { t, language, setLanguage };
}
